import React, { useEffect, useState } from "react";
import { IoIosPeople } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import { getActiveProgramById } from "../../services/ActivePrograms";
import Navbar from "../header/Navbar";
import Sidebar from "../sidebar/Sidebar";
import ActiveModuleEdit from "./ActiveModuleEdit";
import { format, parseISO } from "date-fns";

const ActiveProgramModuleEdit = () => {
  const navigate = useNavigate();
  const { programId, moduleId } = useParams();
  const [editMode, setEditMode] = useState(true);
  const [program, setProgram] = useState(null);
  const getProgram = async () => {
    const response = await getActiveProgramById(programId);
    if (response.status === 200) {
      setProgram(response.data.data[0]);
    }
  };
 
  useEffect(() => {
    getProgram();
  }, [programId]);

  useEffect(() => {
    if (!editMode) {
      navigate(-1);
    }
  }, [editMode]);
  
  return (
    <>
      <Navbar />
      <div className="container-fluid mb-5">
        <div className="row">
          <div className="col-md-2">
            <Sidebar />
          </div>
          <div className="col-md-10 py-4 px-5">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
              <li
                  className="breadcrumb-item cursor-pointer"
                  onClick={() => navigate('/')}
                >
                  Home
                </li>
                <li
                  className="breadcrumb-item cursor-pointer"
                  onClick={() => navigate(-1)}
                >
                 All Programs
                </li>
                <li className="breadcrumb-item active fw-bold" aria-current="page">
                  {program?.programName}
                </li>
              </ol>
            </nav>
            <div className="d-flex justify-content-between p-2">
              <div className="w-100">
                <div className="d-flex gap-3 align-items-center ">
                  <h4 className="chidHeadFont">{program?.programName}</h4>{" "}
                </div>
                <p className="resFont">{program?.description}</p>
                <div className="row pt-4">
                  <div className="col-md-4">
                    <p className="mb-0 text-muted resFont">
                      Created by :{" "}
                      <span className="fw-bold">{program?.createdByDoc}</span>
                    </p>
                  </div>

                  <div className="col-md-4">
                    <p className="mb-0 text-muted resFont">
                      Created on{" "}
                      <span className="fw-bold">
                        {program?.createdAt &&
                          format(
                            parseISO(program?.createdAt),
                            "MMM d, yyyy"
                          )}{" "}
                      </span>
                    </p>
                  </div>

                  <div className="col-md-4">
                    <p className="mb-0 text-muted resFont">
                      <IoIosPeople size={"30px"} /> Members:{" "}
                      <span className="fw-bold">
                        {program?.programMembers?.length + program?.careTeamMembers?.length}
                      </span>
                    </p>
                  </div>

                </div>
              </div>

            </div>
            <hr />
            <div className="mb-5">
              <ActiveModuleEdit setEditMode={setEditMode} moduleId={moduleId} programId={programId}/>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ActiveProgramModuleEdit;
